import { createAction, props } from '@ngrx/store'
import { DataEntityType } from '@tokeet-frontend/tv3-platform'
import { EntityAttributeResponse, EntityAttributes } from '@tokeet-frontend/custom-attrs'

export const LoadCustomAttributes = createAction('[CustomAttribute] Load all')
export const LoadCustomAttributesComplete = createAction(
  '[CustomAttribute] Load all Complete',
  props<{ items: EntityAttributeResponse[] }>()
)

export const LoadCustomAttributesByEntityType = createAction(
  '[CustomAttribute] Load all for type',
  props<{ entityType: DataEntityType; entityId: string }>()
)
export const LoadCustomAttributesByEntityTypeComplete = createAction(
  '[CustomAttribute] Load all for type Complete',
  props<{ item: EntityAttributeResponse }>()
)

export const AddCustomAttribute = createAction(
  '[CustomAttribute] Add',
  props<{
    entityType: DataEntityType
    entityId: string
    payload: EntityAttributes
  }>()
)
export const AddCustomAttributeComplete = createAction(
  '[CustomAttribute] Add Complete',
  props<{ item: EntityAttributeResponse }>()
)
